module.exports = __webpack_public_path__ + "static/media/Spin-1s-75px1.9aa1c034.gif";